import {useNavigate} from "react-router-dom";
import React, {useState} from "react";
import {Button, Form, Grid, Header, Icon, List, Message, Segment} from "semantic-ui-react";
import {getUsername, getCSRFToken, fetchWithAuth} from "./Auth"

const CHANGE_PASSWORD_PATH = process.env.REACT_APP_ICC_TOOL_API_HOST + "password-change/";

export const ChangePassword = () => {
    let navigate = useNavigate();
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmNewPassword, setConfirmNewPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [passErrorList, setPassErrorList] = useState([])
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('')
        setMessage('')
        setPassErrorList([])

        const username = getUsername();
        if (!username) {
            setError("Your username could not be found. Please login again.")
            return
        } else if (!currentPassword) {
            setError("Current Password is required")
            return
        } else if (!newPassword) {
            setError("New Password is required")
            return
        } else if (newPassword !== confirmNewPassword) {
          setError('New passwords do not match');
          return;
        }

        setLoading(true);
        const formData = {username: username, current_password: currentPassword, new_password: newPassword};
        try {
            const resp = await fetchWithAuth(CHANGE_PASSWORD_PATH, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": getCSRFToken()
                },
                credentials: 'include',
                body: JSON.stringify(formData)
            })

            if (resp.ok) {
                setMessage('Password has been changed.');
                setTimeout(() => {
                    sessionStorage.removeItem("user")
                    navigate('/login');
                }, 2000)
            } else if (resp.status === 401) {
                setError('Current Password is incorrect.');
            } else {
                const error_resp = await resp.json();
                if ("errors" in error_resp) {
                    // This will set any/all validation errors
                    setPassErrorList(error_resp["errors"])
                } else {
                    setError('An error occurred changing the password. Please try again.');
                }
            }
        } catch (error) {
            setError('An error occurred changing the password. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Grid textAlign="center" style={{height: '50vh'}} verticalAlign='middle'>
            <Grid.Column style={{maxWidth: 400}}>
                <Header as='h2' textAlign='center'>
                    Change Password
                </Header>
                <Form size="large" onSubmit={handleSubmit} loading={loading}>
                    <Segment>
                        {error && <Message negative>{error}</Message>}
                        {passErrorList.length > 0 &&
                            <Message negative>
                                <List>
                                {passErrorList.map((item) => (
                                    <List.Item>{item}</List.Item>
                                ))}
                                </List>
                            </Message>
                        }
                        <Form.Input
                            fluid
                            icon="lock"
                            iconPosition="left"
                            placeholder="Current Password"
                            type="password"
                            value={currentPassword}
                            onChange={(e) => setCurrentPassword(e.target.value)}
                        />
                        <Form.Input
                            fluid
                            icon="lock"
                            iconPosition="left"
                            placeholder="New Password"
                            type="password"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                        />
                        <Form.Input
                            fluid
                            icon="lock"
                            iconPosition="left"
                            placeholder="Confirm New Password"
                            type="password"
                            value={confirmNewPassword}
                            onChange={(e) => setConfirmNewPassword(e.target.value)}
                        />
                        {message && <Message positive><Icon name="check circle outline" /> {message}</Message>}
                        <Button className="auth-button" fluid>
                            Change Password
                        </Button>
                    </Segment>
                </Form>
            </Grid.Column>
        </Grid>
    );
};
